export default {
        FLIGHT_TYPE_ITEM: 'flight',
        HOTEL_TYPE_ITEM: 'room',
        CAR_TYPE_ITEM: 'car',
        RAIL_TYPE_ITEM: 'rail',
};



// WEBPACK FOOTER //
// ./src/app/modules/trip/config/items.constant.js